<template>
    <button v-bind="$attrs" :value="loading"  @input="$emit('update:loading', $event.target.value)">
        <template v-if="loading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Aguarde...
        </template>
        <template v-else>
            {{label}}
        </template>
    </button>
</template>
<script>
export default {
    inheritAttrs: false,
    name: 'base-button',
    props: {
        label: {
            type: String
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'loading',
        event: 'updateSound'
    }
}
</script>
